import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentPanelOpenedLocation } from './useTrackAgentPanelOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentPanelOpenedLocation } from './useTrackAgentPanelOpened.meta';

export type UseTrackAgentPanelOpenedParams = {
  location: WorkspaceAgentPanelOpenedLocation;
};

export const useTrackAgentPanelOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentPanelOpened = useCallback(
    (params: UseTrackAgentPanelOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentPanelOpened };
};
